import { render } from "./NewsElement.vue?vue&type=template&id=fcde2f2e"
import script from "./NewsElement.vue?vue&type=script&lang=js"
export * from "./NewsElement.vue?vue&type=script&lang=js"

import "./NewsElement.vue?vue&type=style&index=0&id=fcde2f2e&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__